class ProductTabs extends HTMLElement {
    constructor() {
        super();
        
        this.tab = this.querySelectorAll('.tab-title');
        this.tabContents = this.querySelector('.tabs-contents');
        this.tabContent = this.querySelectorAll('.tab-content');
        this.link = this.querySelectorAll('.toggleLink');
        this.readMore = this.querySelectorAll('[data-show-more-toogle]');
        this.tabClose = this.querySelectorAll('.pdViewTab-close');
        this.isVerticalPopup = this.dataset.vertical === 'sidebar'
        this.isVerticalSidebarMobile = this.dataset.verticalMobile === 'sidebar-mobile'

        for (let i = 0; i < this.tab.length; i++) {
            this.tab[i].addEventListener(
                'click',
                this.tabActive.bind(this)
            );
        }
            
        for (let i = 0; i < this.link.length; i++) {
            this.link[i].addEventListener(
                'click',
                this.tabToggle.bind(this)
            );
        }

        document.addEventListener('click', e => {
            if (e.target.matches('[data-show-more-toogle]') || e.target.closest('[data-show-more-toogle]')) {
                this.readMoreReadLess(e)
            }
            else if (e.target.matches('.pdViewTab-close') || e.target.closest('.pdViewTab-close')) {
                this.productTabClose(e)

                if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
                    this.handleVerticalPopupClose(e)
                }
            }
        });

        if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
            // FIX: the overlay does not exist on every template. Guarded so a
            // missing overlay no longer throws and abort the constructor.
            document.querySelector('.background-overlay')?.addEventListener('click', this.onBackgroundClick.bind(this));
        }

        setTimeout(() => {
            if (window.innerWidth > 550) {
                // FIX (TypeError: Cannot read properties of null reading 'offsetHeight').
                // #tab-description-mobile is absent on most templates, so this threw
                // on every page load and killed the rest of the constructor.
                const $thisContent = document.getElementById('tab-description-mobile');
                if (!$thisContent) return;

                const showMore = $thisContent.querySelector('.tab-showMore');
                if (!showMore) return;

                const maxHeight = parseInt(showMore.dataset.desMax, 10);
                if (isNaN(maxHeight)) return;

                if ($thisContent.offsetHeight < maxHeight) {
                    showMore.remove();
                }
            }
        })
    }
    
    tabActive(event){
        event.preventDefault();
        event.stopPropagation();

        // FIX: event.target can be a child of .tab-title (an icon or span), in which
        // case getAttribute('href') returns null and .replace() throws.
        var $this = event.target.closest('.tab-title') || event.target,
            href = $this.getAttribute('href');

        if (!href) return;

        var id = href.replace('#', ''),
            button_tab = document.querySelector('.an-horizontal-shaking');

        if(!$this.classList.contains('is-open')) {
            this.tab.forEach((element, index) => {
                element.classList.remove('is-open');
            });

            $this.classList.add('is-open');
            this.tabContents?.classList.add('is-show');
            button_tab?.classList.add('open-tab-content');

            this.tabContent.forEach((element, index) => {
                if(element.getAttribute('id') == id){
                    element.classList.add('is-active');
                } else {
                    element.classList.remove('is-active');
                }
            });
        }   

        if($this.classList.contains('open-tab-content')) {
            button_tab?.classList.remove('open-tab-content');
        }

        this.checkTabShowMore(id);
    }

    tabToggle(event){
        event.preventDefault();
        event.stopPropagation();
        
        var $this = event.currentTarget,
            $thisContent = $this.parentNode.nextElementSibling;

        if (!$thisContent) return;

        if ($this.classList.contains('popup-mobile') && window.innerWidth <= 551) {
            if ($($thisContent).hasClass('is-show')) {
                $($thisContent).removeClass('is-show');
            }
            else {
                $($thisContent).addClass('is-show');
            }
        }
        else {
            if(window.innerWidth <= 551 && $this.classList.contains('show-mobile')) {
                $this.classList.remove('is-open');
                $this.classList.remove('show-mobile');
                $($thisContent).slideUp('slow');
            }
            else if($this.classList.contains('is-open')){
                $this.classList.remove('is-open');
                if ((this.isVerticalPopup && window.innerWidth > 550) || ($this.matches('.sidebar-mobile') && window.innerWidth <= 550)) {
                    $thisContent.classList.remove('is-show');
                    document.body.classList.remove('tab-popup-show');
                }
                else {
                    $($thisContent).slideUp('slow');
                }
            } else {
                $this.classList.add('is-open');
                if ((this.isVerticalPopup && window.innerWidth > 550) || ($this.classList.contains('sidebar-mobile') && window.innerWidth <= 550)) {
                    if($this.matches('.sidebar-mobile') && window.innerWidth <= 550) {
                        document.body.classList.add('tab-popup-sidebar-show');
                        $thisContent.classList.add('is-show');
                        document.body.classList.add('tab-popup-show');
                    }
                } else {
                    $($thisContent).slideDown('slow');
                }
            }
        }
    }

    readMoreReadLess(event){
        event.preventDefault();
        event.stopPropagation();

        // FIX: the original read `event.target || event.target.closest(...)`, which
        // can never fall through because event.target is always truthy. When the
        // click landed on a child node, getAttribute('href') returned null and
        // .replace() threw. Resolve the toggle element properly instead.
        var $this = event.target.closest('[data-show-more-toogle]') || event.target;
        if (!$this) return;

        var href = $this.getAttribute('href');
        if (!href) return;

        var id = href.replace('#', ''),
            textShowMore = $this.getAttribute('data-show-more-text'),
            textShowLess = $this.getAttribute('data-show-less-text'),
            wrap = $this.closest('.tab-showMore'),
            target = document.getElementById(id);

        if (!wrap || !target) return;

        var desMax = wrap.dataset.desMax;

        if($this.classList.contains('is-less')) {
            wrap.classList.remove('is-less');
            $this.classList.remove('is-less');
            wrap.classList.add('is-show');
            $this.classList.add('is-show');
            $this.innerText = textShowMore;
            target.style.maxHeight = `${desMax}px`;
            this.tabContents?.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
        } else {
            wrap.classList.remove('is-show');
            $this.classList.remove('is-show');
            wrap.classList.add('is-less');
            $this.classList.add('is-less');
            $this.innerText = textShowLess;
            target.style.maxHeight = 'unset';
        }
    }

    productTabClose(event) {
        event.preventDefault();
        event.stopPropagation();

        this.tabContents?.classList.remove('is-show');

        this.tab.forEach((element, index) => {
            element.classList.remove('is-open');
            document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
        });

        this.tabContent.forEach((element, index) => {
            element.classList.remove('is-active');
            document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
        });

        if (window.innerWidth <= 551) {
            // FIX: closest() returns null when the close icon sits outside a
            // .toggle-content wrapper, which threw on mobile.
            event.target.closest('.toggle-content')?.classList.remove('is-show');
        }
    }

    checkTabShowMore(id) {
        if (window.innerWidth > 550) {
            // FIX: same null dereference as the constructor. The element may not
            // exist, and .tab-showMore inside it may not exist either — the original
            // guarded the dataset read with ?. but then called .remove() unguarded.
            const $thisContent = document.getElementById(`${id}`);
            if (!$thisContent) return;

            const showMore = $thisContent.querySelector('.tab-showMore');
            if (!showMore) return;

            const maxHeight = parseInt(showMore.dataset.desMax, 10);
            if (isNaN(maxHeight)) return;

            if ($thisContent.offsetHeight < maxHeight) {
                showMore.remove();
            }
        }
    }

    onBackgroundClick(event) {
        if (event.target.closest('toggle-content.is-show') != null) return 
        document.querySelector('.toggleLink.is-open')?.classList.remove('is-open');
        document.querySelector('.toggle-content.is-show')?.classList.remove('is-show');
        document.body.classList.remove('tab-popup-show');
    }

    handleVerticalPopupClose(event) {
        const icon = event.target
        if (!icon) return;
        icon.closest('.toggle-content')?.classList.remove('is-show')
        icon.closest('.tab-content')?.querySelector('.toggleLink')?.classList.remove('is-open')
        document.body.classList.remove('tab-popup-show')
    }
}

customElements.define('product-tab', ProductTabs);
